<template>
  <!-- <div :key="key" class="superAdmin-layout"> -->
  <div class="superAdmin-layout">
    <Navbar />
    <router-view />
    <Sidebar
      v-if="sidebarName"
      :component-name="sidebarName"
      :component-styles="componentStyles"
      :sidebar-styles="sidebarStyles"
      :sidebar-position="sidebarPosition"
      :component-data="componentData"
    />
  </div>
</template>

<script>
import Navbar from '@/views/SuperAdmin/NavbarSuperAdmin'
import Sidebar from '@/components/Sidebar'

export default {
  name: 'SuperAdminLayout',
  components: {
    Navbar,
    Sidebar
  },
  data: () => ({
    sidebarName: null,
    sidebarStyles: null,
    sidebarRotation: 'right',
    componentStyles: null,
    animationName: 'sidebar',
    componentData: null,
    key: 0
  }),
  computed: {
    error() {
      return this.$store.getters.error
    }
  },
  watch: {
    sidebarName(name) {
      if (name) {
        document.body.style.top = `-${window.scrollY}px`
        document.body.style.position = 'fixed'
      } else {
        const scrollY = document.body.style.top
        document.body.style.position = ''
        document.body.style.top = ''
        window.scrollTo(0, parseInt(scrollY || '0') * -1)
      }
    },
    error(error) {
      let err = null
      if (error.data.error) err = error.data.error
      else if (error?.data?.errors[0]?.error) err = error.data.errors[0].error
      this.$error(err)
    }
  },
  mounted() {
    window.scrollTo(0, 0)
    this.$root.$on('ShowSidebar', params => {
      setTimeout(() => {
        if (params === null) {
          this.sidebarName = params
        } else if (typeof params === 'string') {
          this.sidebarName = params
          this.componentData = null
        } else if (typeof params === 'object') {
          this.sidebarName = params.sidebarName
          this.sidebarStyles = params.sidebarStyles
          this.componentStyles = params.componentStyles
          this.componentData = params.componentData
          this.animationName = !params.animationName ? 'sidebar' : params.animationName
        }
        this.sidebarPosition = !params?.sidebarPosition ? 'right' : params.sidebarPosition
      }, 0)
      this.key += 1
    })
  }
}
</script>
